import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { ContactDetailsType } from "./contactDetails.type";

export type UpsertProviderContactDetailPayload = {
  provider_id?: string;
  institution_id?: string;
  medical_record_request_id?: string;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  department?: string | null;
  is_primary?: boolean | null;
};

export async function upsertProviderContactDetail(
  payload: UpsertProviderContactDetailPayload
): Promise<ContactDetailsType> {
  const slug = ApiEndpoints.contactDetails + "/provider/upsert";

  if (
    !payload?.provider_id &&
    !payload?.institution_id &&
    !payload?.medical_record_request_id
  ) {
    throw new Error(
      "provider_id, institution_id, or medical_record_request_id is required"
    );
  }

  const options = setHeaderOptions({
    method: "POST",
    body: payload,
  });

  return fetchData<ContactDetailsType>(slug, options);
}

export type UpdateContactDetailPayload = {
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  provider?: { id?: string | null; name?: string | null };
  institution?: { id?: string | null; name?: string | null };
  department?: string | null;
};

export async function updateContactDetail(
  id: string,
  payload: UpdateContactDetailPayload
): Promise<ContactDetailsType> {
  if (!id) throw new Error("contact detail id is required");
  const noContactFields =
    !payload ||
    [payload.phone, payload.fax, payload.email].every(
      (v) => v === undefined || v === null || v === ""
    );
  const noNameFields =
    [payload.provider?.name, payload.institution?.name].every(
      (v) => v === undefined || v === null || v === ""
    );

  if (noContactFields && noNameFields) {
    throw new Error(
      "At least one of phone, fax, email, provider.name, or institution.name is required"
    );
  }

  const slug = `${ApiEndpoints.contactDetails}/${encodeURIComponent(id)}`;

  const options = setHeaderOptions({
    method: "PUT",
    body: payload,
  });

  return fetchData<ContactDetailsType>(slug, options);
}
